import { BsExclamationTriangleFill } from "react-icons/bs";
import TableComponent from "../TableComponent";

const OverduePM = ({ overduePm }) => {
  const header = [
    { value: "service_id", label: "Service ID" },
    { value: "vehicle.registration_number", label: "Vehicle" },
    { value: "services_type", label: "Service Type" },
    { value: "priority", label: "Priority" },
    { value: "status", label: "Status" },
    { value: "complete_total", label: "Total" },
  ];

  return (
    <div className="card_container">
      <TableComponent
        heading="Overdue PMs"
        icon={<BsExclamationTriangleFill size={20} />}
        columns={header}
        data={overduePm || []}
        currentPage={1}
        extraClass="overdue_table"
      />
    </div>
  );
};

export default OverduePM;
